import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Team.css";

import ceoImg from "../../assets/Ceo.png";
import hrImg from "../../assets/hr.png";
import managerImg from "../../assets/manager.png";
import cofounderImg from "../../assets/cofounder.png";
import cooImg from "../../assets/coo.png";

const Team = () => {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <section className="team-section" id="team">
      <h2 className="team-title" data-aos="fade-up">
        Our Leadership Team
      </h2>

      <div className="team-members">
        <div className="team-member" data-aos="fade-up">
          <img src={ceoImg} alt="CEO" />
          <h3>Vijay Bhargav</h3>
          <span className="team-role">CEO & Founder</span>
          <p>
            Visionary leader with a passion for innovation and excellence.
            Vijay established VSS to transform how enterprises leverage
            technology.
          </p>
        </div>

        <div className="team-member" data-aos="fade-up" data-aos-delay="150">
          <img src={cofounderImg} alt="Co-Founder" />
          <h3>Perikala Rosaiah</h3>
          <span className="team-role">Co-Founder</span>
          <p>
            Strategic thinker driving business growth and long-term vision
            through strong partnerships and leadership.
          </p>
        </div>

        <div className="team-member" data-aos="fade-up" data-aos-delay="250">
          <img src={cooImg} alt="COO" />
          <h3>Shaik Mahaboob Basha</h3>
          <span className="team-role">Chief Operating Officer</span>
          <p>
            Ensures operational excellence by aligning processes, teams,
            and technology for scalable success.
          </p>
        </div>

        <div className="team-member" data-aos="fade-up" data-aos-delay="350">
          <img src={managerImg} alt="Manager" />
          <h3>Poorna Bindu</h3>
          <span className="team-role">HR Manager</span>
          <p>
            Driving organizational culture and talent acquisition strategies
            to build a motivated workforce.
          </p>
        </div>

        <div className="team-member" data-aos="fade-up" data-aos-delay="450">
          <img src={hrImg} alt="HR" />
          <h3>Tejaswini P</h3>
          <span className="team-role">HR Executive</span>
          <p>
            Fostering employee engagement and operational efficiency while
            championing core values.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Team;
